// Vendor imports
const classNames = require('classnames')
const React = require('react')
const qs = require('qs')
// Shared imports
const BemEntity = require('shared/bem')
const { urlWithoutProtocol } = require('shared/utils')

// Client V2 common imports
const { CapsuleButton } = require('client-v2/common/components/buttons')
const Icon = require('client-v2/common/containers/icons/component')
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('IntoLandingDownloadLinks')

function IntoLandingDownloadLinks(props) {
  const { isAndroid, isDesktop, isIos, iosDeeplinkHref, openInAppTitle, showSMSModal, trackAppDownload } = props

  const handleDownloadClick = React.useCallback(
    event => {
      const { provider } = event.currentTarget.dataset
      event.preventDefault()
      trackAppDownload(provider)
      if (isDesktop && provider === 'ios') {
        showSMSModal()
        return
      }

      const queryString = qs.stringify({
        // Delivered as query parameter when handling the universal links.
        'deeplink_url': location.href,
        // Fallbacks to mix://$deeplink_path when universal links do not work.
        // Docs: https://docs.branch.io/pages/links/integrate/#deep-linking
        '$deeplink_path': urlWithoutProtocol(location.href)
      })
      location.assign(`${iosDeeplinkHref}?${queryString}`)
    },
    [ iosDeeplinkHref, isDesktop, showSMSModal, trackAppDownload ]
  )
  return (
    tag('div', {
      className: classNames(
        props.className,
        bem.block()
      )
    },
      (isIos || isDesktop) && tag(CapsuleButton, {
        className: bem.element('download', 'apple'),
        'data-provider': 'ios',
        href: iosDeeplinkHref,
        onClick: handleDownloadClick
      },
        tag(Icon, { id: 'apple' }),
        tag('div', {
          className: bem.element('link-text')
        },
          openInAppTitle
        )
      ),
      (isAndroid || isDesktop) && tag(CapsuleButton, {
        className: bem.element('download', 'waitlist'),
        'data-provider': 'android',
        href: 'https://forms.gle/3hmi14R6xX5E8mtVA',
        onClick: handleDownloadClick
      },
        tag(Icon, { id: 'android' }),
        tag('div', {
          className: bem.element('link-text')
        },
          'Join the waitlist'
        )
      )
    )
  )
}

module.exports = IntoLandingDownloadLinks
